import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[mdPopover]',
  exportAs: 'mdPopover',
})
export class PopoverDirective implements OnInit, OnChanges, OnDestroy {
  @Input() trigger = 'click';
  @Input() closeOnOutsideClick = true;
  @Input() mdPopover: HTMLElement | string = '';

  @Output() togglePopover: EventEmitter<boolean> = new EventEmitter<boolean>();

  value = false;
  targetElement?: HTMLElement;
  destroy$: Subject<boolean> = new Subject<boolean>();

  @HostBinding('style.cursor') @Input() cursor = 'pointer';

  @HostListener('body:mousedown', ['$event.target'])
  bodyMousedown(element: HTMLElement) {
    if (!this.mdPopover) {
      return;
    }
    if (
      this.closeOnOutsideClick &&
      !this.element.nativeElement.contains(element) &&
      !this.targetElement?.contains(element) &&
      this.element.nativeElement !== element &&
      this.targetElement !== element
    ) {
      this.togglePopup(false);
    }
  }

  constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  togglePopup(value: boolean | null = null) {
    if (!this.mdPopover) {
      return;
    }
    this.value = Boolean(
      value === null
        ? this.targetElement && !this.targetElement.classList.contains('show')
        : value,
    );
    if (this.value) {
      this.renderer.addClass(this.targetElement, 'show');
    } else {
      this.renderer.removeClass(this.targetElement, 'show');
    }
    this.togglePopover.emit(this.value);
  }

  ngOnInit(): void {
    fromEvent(this.element.nativeElement, this.trigger, { capture: true })
      .pipe(takeUntil(this.destroy$))
      .subscribe((e: Event) => {
        if (
          !(e.target instanceof HTMLElement) ||
          (this.targetElement &&
            !e.target.contains(this.targetElement) &&
            e.target !== this.targetElement)
        ) {
          this.togglePopup();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.mdPopover) {
      return;
    }
    if (changes.mdPopover) {
      this.targetElement =
        typeof this.mdPopover === 'string'
          ? document.querySelector(this.mdPopover) || undefined
          : this.mdPopover;
      this.renderer.addClass(this.targetElement, 'active');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
